/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const SpeedometerIcon = ({
  className,
  style,
  color = '#A5BBD4',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M7.71592 11.0643C6.71715 12.2145 6.76627 13.9992 7.82235 15.1003C8.41179 15.7184 9.2018 16.0254 9.98772 16.0254C10.7573 16.0254 11.5227 15.7306 12.1081 15.1453C12.3741 14.8792 12.5829 14.5722 12.7262 14.2489L16.5944 6.74989C16.6967 6.53703 16.4756 6.31599 16.2628 6.41833L8.76381 10.2865C8.37495 10.4584 8.01883 10.7204 7.71592 11.0643ZM9.08309 12.1203C9.33279 11.8706 9.66025 11.7437 9.98772 11.7437C10.3152 11.7437 10.6427 11.8706 10.8964 12.1203C11.3958 12.6197 11.3958 13.4343 10.8964 13.9337C10.6467 14.1834 10.3193 14.3103 9.98772 14.3103C9.66025 14.3103 9.33279 14.1834 9.08309 13.9337C8.57961 13.4302 8.57961 12.6197 9.08309 12.1203ZM18.0188 13.9746C18.0188 12.5583 17.6463 11.1666 16.9382 9.95087C16.6639 9.47604 16.8236 8.87023 17.2984 8.59598C17.7732 8.32172 18.379 8.48136 18.6533 8.95619C19.5334 10.4748 20 12.2104 20 13.9746C20 14.5231 19.5579 14.9652 19.0094 14.9652C18.465 14.9652 18.0188 14.5231 18.0188 13.9746ZM0 13.9746C0 8.4609 4.48629 3.97461 10 3.97461C11.2812 3.97461 12.5297 4.21202 13.7086 4.68685C14.2161 4.89151 14.4617 5.46458 14.2612 5.97215C14.0565 6.47973 13.4834 6.72533 12.9758 6.52475C12.0303 6.14817 11.0274 5.95578 10 5.95578C5.57921 5.95578 1.98117 9.55381 1.98117 13.9746C1.98117 14.5231 1.53909 14.9652 0.990585 14.9652C0.442079 14.9652 0 14.5231 0 13.9746Z"
        fill={color}
      />
    </svg>
  );
};
